import { Link } from 'react-router-dom';
import { Carousel, Image } from 'react-bootstrap';
import Message from './Message';
import { useGetTopProductsQuery } from '../slices/productsApiSlice';

const ProductCarousel = () => {
  const { data: products, isLoading, error } = useGetTopProductsQuery();

  if (isLoading) return <p>Loading...</p>;
  if (error) return <Message variant="danger">{error?.data?.message || error.error}</Message>;

  return (
    <Carousel pause="hover" className="bg-primary mb-4">
      {products.map((product) => {
      

        return (
          <Carousel.Item key={product._id}>
            <Link to={`/product/${product._id}`}>
              <Image
                src={product.images?.[0] || '/images/placeholder.png'}
                alt={product.name}
                fluid
                style={{ maxHeight: '400px', objectFit: 'contain' }}
              />
              <Carousel.Caption className="carousel-caption">
                <h2 className="text-white text-right">
                  {product.name} (${product.price})
                </h2>
              </Carousel.Caption>
            </Link>
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
};

export default ProductCarousel;